module.exports = __webpack_public_path__ + "static/media/user-md.2b7f93e2.svg";